<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='6'>
          <crew-visits
            v-if='project'
            :project='project'
            :helpText='helpText'
          ></crew-visits>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CrewVisits from '@/modules/wos/views/woDetail/CrewVisits'

export default {
  name: 'project-crew-visits',
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    helpText: "This list will only include Crew Visits that are attached to the project directly and not to a specific work order. ( Ie - recurring service )"
  }),
  components: {
    'crew-visits': CrewVisits
  }
}
</script>